// This file is auto-generated by @hey-api/openapi-ts

import { z } from "zod";

/**
 * APIParameter
 */
export const zApiParameter = z.object({
  name: z.string(),
  value: z.string(),
  description: z.union([z.string(), z.null()]).optional(),
  type: z.enum(["Header", "QueryParameter"]),
});

export const zApiParameterType = z.enum(["Header", "QueryParameter"]);

export const zEntityIconToken = z.enum([
  "buildingBank",
  "bitcoin",
  "buildings",
  "mapPin",
  "server",
  "briefcase",
  "worldWww",
  "mail",
  "file",
  "codeDots",
  "radar",
  "serverBolt",
  "affiliate",
  "serverCog",
  "usersGroup",
  "user",
  "deviceMobile",
  "shieldCheck",
  "link",
]);

/**
 * InputParameter
 */
export const zInputParameter = z.object({
  qualifiedName: z.string(),
  value: z.string(),
});

/**
 * InputParameterSpec
 */
export const zInputParameterSpec = z.object({
  qualifiedName: z.string(),
  type: z.enum(["Entity", "Runtime"]),
});

/**
 * QueryAction
 */
export const zQueryAction = z.object({
  id: z.string(),
  name: z.string(),
  method: z.enum(["GET", "POST", "PUT", "DELETE"]),
  url: z.string(),
  description: z.union([z.string(), z.null()]).optional(),
  integrationId: z.string(),
  requestPayload: z.union([z.string(), z.null()]).optional(),
  type: z.enum(["poller", "enrichment"]),
  inputMappings: z.array(zInputParameterSpec).optional(),
  outputMappings: z
    .array(
      z.object({
        id: z.string(),
        relationship: z.string(),
        liquidTemplate: z.string(),
        isRoot: z.union([z.boolean(), z.null()]).optional(),
        outputType: z.enum(["STRING", "LIST"]),
        qualifiedName: z.string(),
      }),
    )
    .optional(),
  apiParameters: z.array(zApiParameter).optional(),
  defaultAgenticSettings: z
    .object({
      id: z.string(),
      confidenceLevel: z.enum(["low", "medium", "high"]),
      costWeight: z.number().int(),
      maxRetries: z.number().int(),
      preconditions: z.string(),
      timeoutSeconds: z.number().int(),
      createdAt: z.string(),
      updatedAt: z.string(),
    })
    .optional(),
  integrationType: z.enum(["Custom", "Google", "LocalTransform"]),
  integrationName: z.string(),
  baseUrl: z.string(),
});

/**
 * Integration
 */
export const zIntegration = z.union([
  z.object({
    name: z.string(),
    type: z.enum(["Custom"]),
    iconUrl: z.union([z.string(), z.null()]).optional(),
    baseUrl: z.string(),
    description: z.union([z.string(), z.null()]).optional(),
    authenticationDetails: z.union([
      z.object({
        authenticationType: z.enum(["Basic"]),
        authenticationDetails: z.object({
          userName: z.string(),
          password: z.string(),
        }),
      }),
      z.object({
        authenticationType: z.enum(["APIKey"]),
        authenticationDetails: z.object({
          apiKey: z.string(),
          apiKeyName: z.string(),
          mappingType: z.enum(["Header", "QueryParameter"]),
        }),
      }),
      z.object({
        authenticationType: z.enum(["None"]),
      }),
    ]),
    apiParameters: z.array(zApiParameter).optional(),
    integrationDetails: z.object({
      connectionName: z.string(),
    }),
    id: z.string(),
    queryActions: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        method: z.enum(["GET", "POST", "PUT", "DELETE"]),
        url: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        integrationId: z.string(),
        requestPayload: z.union([z.string(), z.null()]).optional(),
        type: z.enum(["poller", "enrichment"]),
        inputMappings: z.array(zInputParameterSpec).optional(),
        outputMappings: z
          .array(
            z.object({
              id: z.string(),
              relationship: z.string(),
              liquidTemplate: z.string(),
              isRoot: z.union([z.boolean(), z.null()]).optional(),
              outputType: z.enum(["STRING", "LIST"]),
              qualifiedName: z.string(),
            }),
          )
          .optional(),
      }),
    ),
  }),
  z.object({
    name: z.string(),
    type: z.enum(["Google"]),
    iconUrl: z.union([z.string(), z.null()]).optional(),
    baseUrl: z.string(),
    description: z.union([z.string(), z.null()]).optional(),
    authenticationDetails: z.union([
      z.object({
        authenticationType: z.enum(["Basic"]),
        authenticationDetails: z.object({
          userName: z.string(),
          password: z.string(),
        }),
      }),
      z.object({
        authenticationType: z.enum(["APIKey"]),
        authenticationDetails: z.object({
          apiKey: z.string(),
          apiKeyName: z.string(),
          mappingType: z.enum(["Header", "QueryParameter"]),
        }),
      }),
      z.object({
        authenticationType: z.enum(["None"]),
      }),
    ]),
    apiParameters: z.array(zApiParameter).optional(),
    integrationDetails: z.object({
      clientEmail: z.string(),
      privateKey: z.string(),
      privateKeyId: z.string(),
      delegatedAdminEmail: z.string(),
    }),
    id: z.string(),
    queryActions: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        method: z.enum(["GET", "POST", "PUT", "DELETE"]),
        url: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        integrationId: z.string(),
        requestPayload: z.union([z.string(), z.null()]).optional(),
        type: z.enum(["poller", "enrichment"]),
        inputMappings: z.array(zInputParameterSpec).optional(),
        outputMappings: z
          .array(
            z.object({
              id: z.string(),
              relationship: z.string(),
              liquidTemplate: z.string(),
              isRoot: z.union([z.boolean(), z.null()]).optional(),
              outputType: z.enum(["STRING", "LIST"]),
              qualifiedName: z.string(),
            }),
          )
          .optional(),
      }),
    ),
  }),
  z.object({
    name: z.string(),
    type: z.enum(["LocalTransform"]),
    iconUrl: z.union([z.string(), z.null()]).optional(),
    baseUrl: z.string(),
    description: z.union([z.string(), z.null()]).optional(),
    authenticationDetails: z.union([
      z.object({
        authenticationType: z.enum(["Basic"]),
        authenticationDetails: z.object({
          userName: z.string(),
          password: z.string(),
        }),
      }),
      z.object({
        authenticationType: z.enum(["APIKey"]),
        authenticationDetails: z.object({
          apiKey: z.string(),
          apiKeyName: z.string(),
          mappingType: z.enum(["Header", "QueryParameter"]),
        }),
      }),
      z.object({
        authenticationType: z.enum(["None"]),
      }),
    ]),
    apiParameters: z.array(zApiParameter).optional(),
    id: z.string(),
    queryActions: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        method: z.enum(["GET", "POST", "PUT", "DELETE"]),
        url: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        integrationId: z.string(),
        requestPayload: z.union([z.string(), z.null()]).optional(),
        type: z.enum(["poller", "enrichment"]),
        inputMappings: z.array(zInputParameterSpec).optional(),
        outputMappings: z
          .array(
            z.object({
              id: z.string(),
              relationship: z.string(),
              liquidTemplate: z.string(),
              isRoot: z.union([z.boolean(), z.null()]).optional(),
              outputType: z.enum(["STRING", "LIST"]),
              qualifiedName: z.string(),
            }),
          )
          .optional(),
      }),
    ),
  }),
]);

export const zEntity = z.object({
  id: z.string(),
  name: z.string(),
  qualifiedName: z.string(),
  icon: z.string(),
  colorSchema: z.enum([
    "emerald",
    "yellow",
    "teal",
    "red",
    "blue",
    "neutral",
    "indigo",
    "sky",
    "orange",
    "purple",
    "violet",
    "green",
    "fuchsia",
    "rose",
    "cyan",
    "lime",
    "amber",
    "pink",
  ]),
  defaultValue: z.union([z.string(), z.null()]).optional(),
  description: z.union([z.string(), z.null()]).optional(),
  valueRegExpPattern: z.union([z.string(), z.null()]).optional(),
  isNative: z.boolean(),
  entityClassId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  connectionsCount: z.number().int().gte(0).optional().default(0),
  className: z.string(),
});

export const zEntityClass = z.object({
  id: z.string(),
  name: z.string(),
  iconUrl: z.union([z.string(), z.null()]).optional(),
  description: z.union([z.string(), z.null()]).optional(),
  builtIn: z.boolean(),
  isNative: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  entities: z.array(zEntity),
});

export const zEntityClassUpsert = z.object({
  name: z.string(),
  iconUrl: z.union([z.string(), z.null()]).optional(),
  description: z.union([z.string(), z.null()]).optional(),
});

export const zEntityUpsert = z.object({
  name: z.string(),
  qualifiedName: z.string(),
  icon: z.string(),
  colorSchema: z.enum([
    "emerald",
    "yellow",
    "teal",
    "red",
    "blue",
    "neutral",
    "indigo",
    "sky",
    "orange",
    "purple",
    "violet",
    "green",
    "fuchsia",
    "rose",
    "cyan",
    "lime",
    "amber",
    "pink",
  ]),
  defaultValue: z.union([z.string(), z.null()]).optional(),
  description: z.union([z.string(), z.null()]).optional(),
  valueRegExpPattern: z.union([z.string(), z.null()]).optional(),
  entityClassId: z.string(),
});

export const zPaginatedResponse = z.object({
  totalItems: z.number().int().gte(0),
  totalPages: z.number().int().gte(0),
  currentPage: z.number().int().gt(0),
  pageSize: z.number().int().gt(0),
});

export const zValidationError = z.object({
  code: z.string().optional(),
  message: z.string(),
  errors: z.record(z.string()).optional(),
});

export const zError = z.object({
  code: z.string().optional(),
  message: z.string(),
  details: z.string().optional(),
});

export const zGraphSummary = z.object({
  id: z.string(),
  name: z.string(),
  format: z
    .enum(["manual", "fcose", "verticaltree", "horizontaltree", "circle"])
    .nullable()
    .optional(),
  clustersEnabled: z.union([z.boolean(), z.null()]).optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const zEntityColorSchema = z.enum([
  "emerald",
  "yellow",
  "teal",
  "red",
  "blue",
  "neutral",
  "indigo",
  "sky",
  "orange",
  "purple",
  "violet",
  "green",
  "fuchsia",
  "rose",
  "cyan",
  "lime",
  "amber",
  "pink",
]);

export const zIntegrationAuthenticationType = z.enum([
  "Basic",
  "APIKey",
  "None",
]);

export const zWorkflowStatus = z.enum([
  "INITIALIZING",
  "RUNNING",
  "SUCCEEDED",
  "SUCCEEDED_PENDING",
  "FAILED",
  "TIMED_OUT",
  "ABORTED",
  "PENDING_REDRIVE",
  "PENDING",
  "QUEUED",
]);

export const zWorkflow = z.object({
  id: z.string(),
  status: zWorkflowStatus,
  title: z.string().min(1),
  sourceId: z.string().optional(),
  graphHostId: z.string().optional(),
  timestamp: z.string().datetime(),
  rawResponse: z.string().optional(),
  queryActionId: z.string().optional(),
  relationshipIds: z.array(z.string()),
});

export const zGraphNode = z.object({
  id: z.string().min(1),
  value: z.string().min(1),
  workflowIds: z.array(z.string()).optional(),
  position: z
    .object({
      x: z.number(),
      y: z.number(),
    })
    .optional(),
  flagColor: z.string().optional(),
  isFlagged: z.boolean().optional(),
  clusterId: z.string().optional(),
  icon: z.string().optional(),
  colorSchema: z
    .enum([
      "emerald",
      "yellow",
      "teal",
      "red",
      "blue",
      "neutral",
      "indigo",
      "sky",
      "orange",
      "purple",
      "violet",
      "green",
      "fuchsia",
      "rose",
      "cyan",
      "lime",
      "amber",
      "pink",
    ])
    .optional(),
  entityName: z.string().optional(),
  entityQualifiedName: z.string(),
});

/**
 * Sort workflows by timestamp in ascending or descending order
 */
export const zSortDirection = z.enum(["asc", "desc"]);

export const zUser = z.object({
  id: z.string(),
  fullName: z.string(),
  email: z.string(),
  status: z.enum(["Active", "Pending", "Disabled"]),
});

export const zGraphEdge = z.object({
  id: z.string().min(1),
  value: z.string().min(1),
  sourceId: z.string().min(1),
  targetId: z.string().min(1),
  workflowIds: z.array(z.string()).optional(),
});

export const zGraphCluster = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  nodeIds: z.array(z.string().min(1)),
  icon: z.string().optional(),
  colorSchema: z
    .enum([
      "emerald",
      "yellow",
      "teal",
      "red",
      "blue",
      "neutral",
      "indigo",
      "sky",
      "orange",
      "purple",
      "violet",
      "green",
      "fuchsia",
      "rose",
      "cyan",
      "lime",
      "amber",
      "pink",
    ])
    .optional(),
  entityName: z.string().optional(),
  entityQualifiedName: z.string(),
});

export const zApiKeyMetadata = z.object({
  id: z.string(),
  description: z.string().optional(),
  status: z.enum(["Active", "Disabled"]),
  creator: z.string(),
  createdAt: z.string(),
});

export const zPageParam = z.number().int().gte(1).default(1);

export const zPageSizeParam = z.number().int().gte(1).default(20);

export const zEventSummary = z.object({
  id: z.string(),
  summary: z.string(),
  assessment: z.string(),
  source: z.string(),
  status: zWorkflowStatus,
  createdAt: z.string(),
  updatedAt: z.string(),
  durationSeconds: z.number(),
});

export const zEventDetail = zEventSummary.and(
  z.object({
    ip: z.string(),
    objective: z.string(),
    location: z.string(),
    userAgent: z.string(),
    severity: z.string().optional(),
    triggerPayload: z.string(),
    resultPayload: z.string(),
    timeline: z.array(
      z.object({
        id: z.string(),
        action: z.string(),
        time: z.string(),
        start: z.string(),
        end: z.string(),
        duration: z.number(),
        status: z.string(),
        description: z.string(),
        summary: z.string(),
        plan: z.string(),
        responsePayload: z.string(),
        toolName: z.string().optional(),
        inputPayload: z.string(),
      }),
    ),
    graphId: z.string().uuid().optional(),
    nodes: z
      .array(
        z.object({
          id: z.string(),
          value: z.string(),
          entityId: z.string(),
          entityName: z.string(),
          entityQualifiedName: z.string(),
          graphId: z.string().uuid(),
        }),
      )
      .optional(),
  }),
);

export const zCopilotAction = z.object({
  description: z.string(),
  params: z.object({
    graphId: z.string(),
    nodeId: z.string(),
    queryAction: z.object({
      id: z.string(),
      inputParameters: z.array(zInputParameter),
      selectedOutputMappingIds: z.array(z.string()).min(1),
    }),
  }),
});

export const zGraphCsvUploadMapping = z.object({
  columns: z.record(
    z.union([
      z.object({
        ignore: z.literal(false),
        entityQualifiedName: z.string().min(1),
      }),
      z.object({
        ignore: z.literal(true),
      }),
    ]),
  ),
  relationships: z
    .array(
      z.object({
        source: z.object({
          column: z.string(),
          entityQualifiedName: z.string(),
        }),
        target: z.object({
          column: z.string(),
          entityQualifiedName: z.string(),
        }),
        type: z.string(),
      }),
    )
    .optional(),
});

export const zCopilotMessage = z.object({
  sessionId: z.string(),
  messageId: z.string(),
  role: z.enum(["user", "assistant"]),
  content: z.string(),
  createdAt: z.string(),
  actions: z.array(zCopilotAction).optional(),
  isPartial: z.boolean().default(false),
});

/**
 * QueryActionForNode
 *
 * A Query Action as represented in the node graph
 */
export const zQueryActionForNode = z.object({
  id: z.string(),
  name: z.string().min(2),
  description: z.string(),
  integrationDescription: z.string(),
  integrationId: z.string(),
  integrationName: z.string().min(2),
  alreadyRun: z.boolean(),
  lastRun: z.string().datetime().optional(),
  costWeight: z.number().int().gte(0).lte(5).optional(),
  inputMappings: z.array(zInputParameterSpec).min(1),
  outputMappings: z
    .array(
      z.object({
        id: z.string(),
        entityId: z.string(),
        alertSourceId: z.union([z.string(), z.null()]).optional(),
        relationship: z.string(),
        isRoot: z.union([z.boolean(), z.null()]).optional(),
        outputType: z.enum(["STRING", "LIST"]),
        outputEntityType: z.string(),
        outputEntityQualifiedName: z.string(),
        outputEntityDescription: z.string().optional(),
        alreadyRun: z.boolean(),
        lastRun: z.string().datetime().optional(),
      }),
    )
    .min(1),
});

/**
 * NotificationProvider
 */
export const zDestination = z.union([
  z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    type: z.enum(["Slack"]),
    providerDetails: z.object({
      url: z.string().url(),
      channel: z.string().min(1),
      username: z.string().optional(),
    }),
    id: z.string(),
  }),
  z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    type: z.enum(["Email"]),
    providerDetails: z.object({
      email: z.string().email(),
      subject: z.string().min(1),
      text: z.string().min(1),
    }),
    id: z.string(),
  }),
  z.object({
    name: z.string().min(1),
    description: z.string().optional(),
    type: z.enum(["Webhook"]),
    providerDetails: z.object({
      url: z.string().url(),
      method: z.enum(["GET", "POST", "PUT", "DELETE"]),
    }),
    id: z.string(),
  }),
]);

export const zAgent = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  objective: z.string(),
  url: z.string(),
  successCriteria: z.string(),
  failureCriteria: z.string(),
  returnSchema: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  exampleJson: z.union([z.string(), z.null()]).optional(),
  toolMappings: z.array(
    z.object({
      queryActionId: z.string(),
      agenticSettings: z
        .object({
          confidenceLevel: z.enum(["low", "medium", "high"]),
          costWeight: z.number().int(),
          maxRetries: z.number().int(),
          preconditions: z.string(),
          timeoutSeconds: z.number().int(),
        })
        .optional(),
    }),
  ),
  notificationProviders: z.array(zDestination).optional(),
  entityMappings: z.array(
    z.object({
      id: z.string(),
      relationship: z.string(),
      liquidTemplate: z.string(),
      isRoot: z.union([z.boolean(), z.null()]).optional(),
      outputType: z.enum(["STRING", "LIST"]),
      qualifiedName: z.string(),
    }),
  ),
});

/**
 * KnowledgeBase
 */
export const zKnowledgeBase = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  tags: z.array(z.string()),
  createdAt: z.string(),
  updatedAt: z.string(),
  files: z.array(
    z.object({
      id: z.string().uuid(),
      filename: z.string(),
      description: z.string(),
      tags: z.array(z.string()),
      mimeType: z.string(),
      sizeBytes: z.number(),
      uploadedAt: z.string().datetime(),
      workflowId: z.union([z.string().uuid(), z.null()]),
      processingStatus: zWorkflowStatus.optional(),
      downloadUrl: z.string().url(),
    }),
  ),
});

export const zGraphLayout = z.enum([
  "manual",
  "fcose",
  "verticaltree",
  "horizontaltree",
  "circle",
]);

export const zGraphDetails = z.object({
  nodes: z.array(zGraphNode),
  edges: z.array(zGraphEdge),
  clusters: z.array(zGraphCluster).optional(),
  layout: zGraphLayout.optional(),
});

/**
 * WorkflowStreamEvent
 *
 * Server-Sent Event payload for workflow stream updates
 */
export const zWorkflowStreamEvent = z.union([
  z.object({
    type: z.enum(["connected"]),
    graphId: z.string(),
  }),
  z.object({
    type: z.enum(["workflow:started"]),
    workflow: zWorkflow,
  }),
  z.object({
    type: z.enum(["workflow:success"]),
    workflow: zWorkflow,
    graphDetails: zGraphDetails.optional(),
  }),
  z.object({
    type: z.enum(["workflow:failed"]),
    workflow: zWorkflow,
  }),
  z.object({
    type: z.enum(["error"]),
    error: z.string(),
  }),
]);

/**
 * SseEvent
 *
 * Server-Sent Event wrapper. The 'data' field contains the JSON-serialized WorkflowStreamEvent.
 */
export const zSseEvent = z.object({
  event: z
    .enum([
      "connected",
      "workflow:failed",
      "workflow:started",
      "workflow:success",
      "error",
    ])
    .optional(),
  id: z.string().optional(),
  retry: z.number().int().gte(0).optional(),
  data: zWorkflowStreamEvent,
});

export const zCopilotStreamingEvent = z.union([
  z.object({
    type: z.enum(["chunk"]),
    text: z.string(),
  }),
  z.object({
    type: z.enum(["end"]),
    answer: z.string(),
    actions: z.array(zCopilotAction).optional(),
  }),
  z.object({
    type: z.enum(["error"]),
    error: z.string(),
  }),
  z.object({
    type: z.enum(["action"]),
    action: zCopilotAction,
  }),
]);

/**
 * CopilotSseEvent
 *
 * Server-Sent Event wrapper. The 'data' field contains the JSON-serialized CopilotStreamingEventDTO.
 */
export const zCopilotSseEvent = z.object({
  event: z.enum(["chunk", "action", "end", "error"]).optional(),
  id: z.string().optional(),
  retry: z.number().int().gte(0).optional(),
  data: zCopilotStreamingEvent,
});

export const zCopilotSession = z.object({
  id: z.string(),
  userId: z.string(),
  createdAt: z.string(),
  type: z.enum(["chat", "graph"]).optional(),
  name: z.string().optional(),
});

export const zCopilotConversation = z.object({
  session: zCopilotSession,
  messages: z.array(zCopilotMessage),
});

export const zPoller = z.object({
  id: z.string(),
  name: z.string(),
  queryActionId: z.string(),
  alertSourceId: z.string(),
  workflowId: z.union([z.string().uuid(), z.null()]).optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
  agentName: z.string(),
  queryActionName: z.string(),
  integrationType: z.string(),
  integrationIconUrl: z.union([z.string(), z.null()]).optional(),
  workflowStatus: z
    .enum([
      "INITIALIZING",
      "RUNNING",
      "SUCCEEDED",
      "SUCCEEDED_PENDING",
      "FAILED",
      "TIMED_OUT",
      "ABORTED",
      "PENDING_REDRIVE",
      "PENDING",
      "QUEUED",
    ])
    .nullable()
    .optional(),
  inputMappings: z.array(zInputParameter).optional(),
  lastRunAt: z.union([z.string(), z.null()]).optional(),
});

export const zQueryActionType = z.enum(["poller", "enrichment"]);

export const zExtensionPolicy = z.object({
  id: z.number().int(),
  teamId: z.string(),
  url: z.string(),
  type: z.enum(["allow", "block"]),
  urlType: z.enum(["exact", "subdomain"]),
  hasImpersonationGuard: z.boolean(),
  hasPasswordLeakageGuard: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const zExtensionInfoBlock = z.object({
  id: z.number().int(),
  teamId: z.string(),
  url: z.string(),
  urlType: z.enum(["exact", "subdomain"]),
  title: z.string(),
  body: z.string(),
  enabled: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const zIdentity = z.object({
  value: z.string(),
  type: z.string(),
  online: z.boolean(),
  lastSeenAt: z.union([z.string(), z.null()]).optional(),
  riskScore: z.enum(["low", "medium", "high"]).nullable().optional(),
});

export const zConsolidatedValueDto = z.object({
  firstSeenAt: z.string(),
  lastSeenAt: z.string(),
  value: z.string(),
});

export const zTemporalFeatureResponseDto = z.object({
  featureType: z.enum(["temporal"]),
  count: z.number(),
});

export const zDashboardFeatureEntryDto = z.union([
  z.object({
    featureType: z.enum(["consolidated"]),
    updatedTs: z.union([z.string(), z.null()]).optional(),
    values: z.array(zConsolidatedValueDto),
  }),
  zTemporalFeatureResponseDto,
]);

export const zRecentActivity = z.object({
  id: z.string(),
  type: z.string(),
  time: z.string(),
  description: z.string(),
  identityId: z.string(),
});

export const zIdentityAlert = z.object({
  description: z.string(),
  id: z.string(),
  severity: z.enum(["low", "medium", "high", "critical"]),
  status: z.enum(["open", "investigating", "resolved"]),
  time: z.string(),
});

export const zExtensionMetrics = z.object({
  enrolledUsers: z.number().int().gte(0),
  totalEndpoints: z.number().int().gte(0),
  onlineEndpoints: z.number().int().gte(0),
  activeEndpoints: z.object({
    hours24: z.number().int().gte(0),
    days7: z.number().int().gte(0),
    days30: z.number().int().gte(0),
  }),
  staleEndpoints: z.number().int().gte(0),
  browserSignals: z.object({
    hours24: z.number().int().gte(0),
    days7: z.number().int().gte(0),
    days30: z.number().int().gte(0),
  }),
});

export const zGetDocsYmlData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zListMcpToolsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zListMcpToolsResponse = z.object({
  tools: z.array(z.unknown()),
  nextCursor: z.union([z.string(), z.null()]),
});

export const zListMcpToolsJsonRpcData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zListMcpToolsJsonRpcResponse = z.object({
  jsonrpc: z.string(),
  id: z.number(),
  result: z.object({
    tools: z.array(z.unknown()),
    nextCursor: z.union([z.string(), z.null()]),
  }),
});

export const zListInternalMcpToolsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zListInternalMcpToolsResponse = z.object({
  tools: z.array(z.unknown()),
  nextCursor: z.union([z.string(), z.null()]),
});

export const zListMcpToolsByWebhookData = z.object({
  body: z.never().optional(),
  path: z.object({
    webhookId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zListMcpToolsByWebhookResponse = z.object({
  tools: z.array(z.unknown()),
  nextCursor: z.union([z.string(), z.null()]),
});

export const zHydrateToolData = z.object({
  body: z.record(z.string()).optional(),
  path: z.object({
    toolId: z.string(),
  }),
  query: z.never().optional(),
});

export const zListAgentsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListAgentsResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zAgent),
  }),
);

export const zCreateAgentData = z.object({
  body: z.object({
    name: z.string(),
    description: z.string(),
    objective: z.string(),
    successCriteria: z.string(),
    failureCriteria: z.string(),
    returnSchema: z.string(),
    exampleJson: z.union([z.string(), z.null()]).optional(),
    toolMappings: z.array(
      z.object({
        queryActionId: z.string(),
        agenticSettings: z
          .object({
            confidenceLevel: z.enum(["low", "medium", "high"]),
            costWeight: z.number().int(),
            maxRetries: z.number().int(),
            preconditions: z.string(),
            timeoutSeconds: z.number().int(),
          })
          .optional(),
      }),
    ),
    entityMappings: z
      .array(
        z.object({
          qualifiedName: z.string(),
          relationship: z.string(),
          liquidTemplate: z.string(),
          outputType: z.enum(["STRING", "LIST"]),
          isRoot: z.union([z.boolean(), z.null()]).optional(),
        }),
      )
      .optional(),
    notificationProviders: z
      .array(
        z.object({
          providerId: z.string(),
        }),
      )
      .optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateAgentResponse = zAgent;

export const zDeleteAgentData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteAgentResponse = z.object({
  message: z.string(),
});

export const zGetAgentData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetAgentResponse = zAgent;

export const zUpdateAgentData = z.object({
  body: z
    .object({
      name: z.string().optional(),
      description: z.string().optional(),
      objective: z.string().optional(),
      successCriteria: z.string().optional(),
      failureCriteria: z.string().optional(),
      returnSchema: z.string().optional(),
      exampleJson: z.union([z.string(), z.null()]).optional(),
      toolMappings: z
        .array(
          z.object({
            queryActionId: z.string(),
            agenticSettings: z
              .object({
                confidenceLevel: z.enum(["low", "medium", "high"]),
                costWeight: z.number().int(),
                maxRetries: z.number().int(),
                preconditions: z.string(),
                timeoutSeconds: z.number().int(),
              })
              .optional(),
          }),
        )
        .optional(),
      entityMappings: z
        .array(
          z.object({
            qualifiedName: z.string(),
            relationship: z.string(),
            liquidTemplate: z.string(),
            outputType: z.enum(["STRING", "LIST"]),
            isRoot: z.union([z.boolean(), z.null()]).optional(),
          }),
        )
        .optional(),
      notificationProviders: z
        .array(
          z.object({
            providerId: z.string(),
          }),
        )
        .optional(),
    })
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateAgentResponse = zAgent;

export const zSearchAgentsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    searchTerm: z.string().min(1),
  }),
});

/**
 * Default Response
 */
export const zSearchAgentsResponse = z.array(zAgent);

export const zListApiKeysData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListApiKeysResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zApiKeyMetadata),
  }),
);

export const zCreateApiKeyData = z.object({
  body: z
    .object({
      description: z.string().optional(),
    })
    .optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateApiKeyResponse = zApiKeyMetadata.and(
  z.object({
    key: z.string(),
  }),
);

export const zDeleteApiKeyData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteApiKeyResponse = z.object({
  message: z.string(),
});

export const zUpdateApiKeyData = z.object({
  body: z
    .object({
      description: z.string().optional(),
    })
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateApiKeyResponse = zApiKeyMetadata;

export const zCopilotQueryStreamData = z.object({
  body: z.object({
    sessionId: z.string(),
    message: z.string().min(1),
    context: z
      .object({
        currentRoute: z.string().optional(),
        userId: z.string().optional(),
        graphId: z.string().optional(),
        selectedNodes: z.array(z.string()).optional(),
        groupedNodes: z
          .array(
            z.object({
              groupName: z.string(),
              nodeIds: z.array(z.string()),
            }),
          )
          .optional(),
      })
      .optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Server-Sent Events stream
 */
export const zCopilotQueryStreamResponse = zCopilotSseEvent;

export const zCreateConversationData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      sessionId: z.string().optional(),
      type: z.enum(["chat", "graph"]).optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zCreateConversationResponse = zCopilotSession;

export const zGetConversationData = z.object({
  body: z.object({
    sessionId: z.string(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetConversationResponse = zCopilotConversation;

export const zGetSessionListData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      type: z.enum(["chat", "graph"]).optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zGetSessionListResponse = z.array(zCopilotSession);

export const zGenerateLiquidTemplateData = z.object({
  body: z.object({
    userDescription: z.string().min(1).max(2000),
    jsonContext: z.string().min(1).max(150000),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGenerateLiquidTemplateResponse = z.object({
  template: z.string(),
  noMatch: z.boolean().optional(),
  message: z.string().optional(),
});

export const zListIdentityAlertsData = z.object({
  body: z.never().optional(),
  path: z.object({
    identityId: z.string().min(1),
  }),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListIdentityAlertsResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zIdentityAlert),
  }),
);

export const zGetIdentityPresenceData = z.object({
  body: z.never().optional(),
  path: z.object({
    identityId: z.string().min(1),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetIdentityPresenceResponse = z.object({
  online: z.boolean(),
  lastSeenAt: z.union([z.string(), z.null()]),
});

export const zListIdentityRecentActivityData = z.object({
  body: z.never().optional(),
  path: z.object({
    identityId: z.string().min(1),
  }),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListIdentityRecentActivityResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zRecentActivity),
  }),
);

export const zListIdentitiesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      cursor: z.string().optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListIdentitiesResponse = z.object({
  nextCursor: z.union([z.string(), z.null()]),
  hasMore: z.boolean(),
  items: z.array(zIdentity),
});

export const zQueryFeaturesByUserSlugData = z.object({
  body: z.never().optional(),
  path: z.object({
    userSlug: z.string().min(1),
  }),
  query: z
    .object({
      slug: z.string().optional(),
      after_timestamp: z.string().optional(),
      before_timestamp: z.string().optional(),
      limit: z.number().optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zQueryFeaturesByUserSlugResponse = z.object({
  features: z.record(zDashboardFeatureEntryDto),
});

export const zGetExtensionMetricsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetExtensionMetricsResponse = zExtensionMetrics;

export const zGetPollerMetricsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetPollerMetricsResponse = z.object({
  activePollers: z.number().int().gte(0),
  pollerRuns: z.object({
    hours24: z.number().int().gte(0),
    days7: z.number().int().gte(0),
    days30: z.number().int().gte(0),
  }),
  avgDurationMs: z.union([z.number(), z.null()]),
});

export const zListBrowserAlertsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      userId: z.string().min(1).optional(),
      userEmail: z.string().min(1).optional(),
      days: z.number().int().gt(0).lte(3650).optional(),
      from: z.string().optional(),
      to: z.string().optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListBrowserAlertsResponse = z.object({
  alerts: z.array(
    z.object({
      id: z.number().int(),
      teamId: z.string(),
      userId: z.union([z.string(), z.null()]).optional(),
      userEmail: z.union([z.string(), z.null()]).optional(),
      detectionRuleId: z.number().int(),
      severity: z.enum(["low", "medium", "high", "critical"]),
      url: z.string(),
      reason: z.union([z.string(), z.null()]).optional(),
      investigationId: z.union([z.string(), z.null()]).optional(),
      status: z.enum(["open", "investigating", "resolved"]),
      createdAt: z.string(),
      occurredAt: z.union([z.string(), z.null()]).optional(),
      detectionRule: z.object({
        id: z.number().int(),
        teamId: z.string(),
        name: z.string(),
        ruleType: z.string(),
        evaluationMode: z.enum(["url", "search_input"]),
        patterns: z.array(z.string()),
        keywords: z.array(z.string()),
        action: z.enum(["create_alert", "log_signal"]),
        severity: z.enum(["low", "medium", "high", "critical"]),
        enabled: z.boolean(),
        createdAt: z.string(),
        updatedAt: z.string(),
      }),
    }),
  ),
});

export const zPostBrowserAlertData = z.object({
  body: z.object({
    detectionRuleId: z.number().int().gt(0),
    type: z.string().min(1),
    url: z.string().min(1),
    occurredAt: z.string().datetime().optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zPostBrowserAlertResponse = z.object({
  id: z.number().int(),
  teamId: z.string(),
  userId: z.union([z.string(), z.null()]).optional(),
  userEmail: z.union([z.string(), z.null()]).optional(),
  detectionRuleId: z.number().int(),
  severity: z.enum(["low", "medium", "high", "critical"]),
  url: z.string(),
  reason: z.union([z.string(), z.null()]).optional(),
  investigationId: z.union([z.string(), z.null()]).optional(),
  status: z.enum(["open", "investigating", "resolved"]),
  createdAt: z.string(),
  occurredAt: z.union([z.string(), z.null()]).optional(),
});

export const zGetBrowserAlertData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.number().int().gt(0),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetBrowserAlertResponse = z.object({
  id: z.number().int(),
  teamId: z.string(),
  userId: z.union([z.string(), z.null()]).optional(),
  userEmail: z.union([z.string(), z.null()]).optional(),
  detectionRuleId: z.number().int(),
  severity: z.enum(["low", "medium", "high", "critical"]),
  url: z.string(),
  reason: z.union([z.string(), z.null()]).optional(),
  investigationId: z.union([z.string(), z.null()]).optional(),
  status: z.enum(["open", "investigating", "resolved"]),
  createdAt: z.string(),
  occurredAt: z.union([z.string(), z.null()]).optional(),
  detectionRule: z.object({
    id: z.number().int(),
    teamId: z.string(),
    name: z.string(),
    ruleType: z.string(),
    evaluationMode: z.enum(["url", "search_input"]),
    patterns: z.array(z.string()),
    keywords: z.array(z.string()),
    action: z.enum(["create_alert", "log_signal"]),
    severity: z.enum(["low", "medium", "high", "critical"]),
    enabled: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
  }),
});

export const zListBrowserSignalsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      userId: z.string().min(1).optional(),
      userEmail: z.string().min(1).optional(),
      days: z.number().int().gt(0).lte(3650).optional(),
      from: z.string().optional(),
      to: z.string().optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListBrowserSignalsResponse = z.object({
  signals: z.array(
    z.object({
      id: z.number().int(),
      teamId: z.string(),
      userId: z.union([z.string(), z.null()]).optional(),
      userEmail: z.union([z.string(), z.null()]).optional(),
      type: z.string(),
      url: z.string(),
      host: z.union([z.string(), z.null()]).optional(),
      detectionRuleId: z.number().int(),
      metadata: z
        .union([
          z.object({
            urlCount: z.number().optional(),
            duration: z.number().optional(),
            platform: z.string().optional(),
            query: z.string().optional(),
            category: z.string().optional(),
            section: z.string().optional(),
            action: z.string().optional(),
          }),
          z.null(),
        ])
        .optional(),
      createdAt: z.string(),
      occurredAt: z.union([z.string(), z.null()]).optional(),
      detectionRule: z.object({
        id: z.number().int(),
        teamId: z.string(),
        name: z.string(),
        ruleType: z.string(),
        evaluationMode: z.enum(["url", "search_input"]),
        patterns: z.array(z.string()),
        keywords: z.array(z.string()),
        action: z.enum(["create_alert", "log_signal"]),
        severity: z.enum(["low", "medium", "high", "critical"]),
        enabled: z.boolean(),
        createdAt: z.string(),
        updatedAt: z.string(),
      }),
    }),
  ),
});

export const zPostBrowserSignalData = z.object({
  body: z.object({
    detectionRuleId: z.number().int().gt(0),
    type: z.string().min(1),
    url: z.string().min(1),
    metadata: z
      .object({
        urlCount: z.number().optional(),
        duration: z.number().optional(),
        platform: z.string().optional(),
        query: z.string().optional(),
        category: z.string().optional(),
        section: z.string().optional(),
        action: z.string().optional(),
      })
      .optional(),
    occurredAt: z.string().datetime().optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zPostBrowserSignalResponse = z.object({
  id: z.number().int(),
  teamId: z.string(),
  userId: z.union([z.string(), z.null()]).optional(),
  userEmail: z.union([z.string(), z.null()]).optional(),
  type: z.string(),
  url: z.string(),
  host: z.union([z.string(), z.null()]).optional(),
  detectionRuleId: z.number().int(),
  metadata: z
    .union([
      z.object({
        urlCount: z.number().optional(),
        duration: z.number().optional(),
        platform: z.string().optional(),
        query: z.string().optional(),
        category: z.string().optional(),
        section: z.string().optional(),
        action: z.string().optional(),
      }),
      z.null(),
    ])
    .optional(),
  createdAt: z.string(),
  occurredAt: z.union([z.string(), z.null()]).optional(),
});

export const zPostBrowserExtensionEnrollmentData = z.object({
  body: z.object({
    installId: z.string().min(1),
    userEmail: z.string().email().optional(),
    browserType: z.string().min(1).optional(),
    browserVersion: z.string().min(1).optional(),
    os: z.string().min(1).optional(),
    extensionVersion: z.string().min(1).optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zPostBrowserExtensionEnrollmentResponse = z.object({
  userEmail: z.string(),
  installId: z.string(),
  enrolledAt: z.string(),
  lastSeenAt: z.string(),
});

export const zPostBrowserExtensionHeartbeatData = z.object({
  body: z.object({
    installId: z.string().min(1),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zPostBrowserExtensionHeartbeatResponse = z.object({
  installId: z.string(),
  lastSeenAt: z.string(),
});

export const zListEntityClassesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListEntityClassesResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zEntityClass),
  }),
);

export const zCreateEntityClassData = z.object({
  body: zEntityClassUpsert.optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateEntityClassResponse = z.object({
  id: z.string(),
  name: z.string(),
  iconUrl: z.union([z.string(), z.null()]).optional(),
  description: z.union([z.string(), z.null()]).optional(),
  builtIn: z.boolean(),
  isNative: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const zDeleteEntityClassData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteEntityClassResponse = z.object({
  message: z.string(),
});

export const zGetEntityClassData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetEntityClassResponse = zEntityClass;

export const zUpdateEntityClassData = z.object({
  body: z
    .object({
      name: z.string().optional(),
      iconUrl: z.union([z.string(), z.null()]).optional(),
      description: z.union([z.string(), z.null()]).optional(),
    })
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateEntityClassResponse = z.object({
  id: z.string(),
  name: z.string(),
  iconUrl: z.union([z.string(), z.null()]).optional(),
  description: z.union([z.string(), z.null()]).optional(),
  builtIn: z.boolean(),
  isNative: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const zGetEventData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string().min(1),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetEventResponse = zEventDetail;

export const zListEventsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      cursor: z.string().optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListEventsResponse = z.object({
  nextCursor: z.union([z.string(), z.null()]),
  hasMore: z.boolean(),
  items: z.array(zEventSummary),
});

export const zCancelWorkflowData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string().min(1),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCancelWorkflowResponse = z.object({
  id: z.string(),
});

export const zSearchEventsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    searchTerm: z.string().min(1),
  }),
});

/**
 * Default Response
 */
export const zSearchEventsResponse = z.array(zEventSummary);

export const zListExtensionInfoBlocksData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zListExtensionInfoBlocksResponse = z.array(zExtensionInfoBlock);

export const zCreateExtensionInfoBlockData = z.object({
  body: z.object({
    url: z.string().min(1),
    urlType: z.enum(["exact", "subdomain"]),
    title: z.string().min(1),
    body: z.string().min(1),
    enabled: z.boolean().optional().default(true),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateExtensionInfoBlockResponse = zExtensionInfoBlock;

export const zDeleteExtensionInfoBlockData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.number().int().gt(0),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteExtensionInfoBlockResponse = z.object({
  message: z.string(),
});

export const zGetExtensionInfoBlockData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.number().int().gt(0),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetExtensionInfoBlockResponse = zExtensionInfoBlock;

export const zUpdateExtensionInfoBlockData = z.object({
  body: z.object({
    url: z.string().min(1),
    urlType: z.enum(["exact", "subdomain"]),
    title: z.string().min(1),
    body: z.string().min(1),
    enabled: z.boolean().optional().default(true),
  }),
  path: z.object({
    id: z.number().int().gt(0),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateExtensionInfoBlockResponse = zExtensionInfoBlock;

export const zListExtensionPoliciesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListExtensionPoliciesResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zExtensionPolicy),
  }),
);

export const zCreateExtensionPolicyData = z.object({
  body: z.object({
    url: z.string().min(1),
    type: z.enum(["allow", "block"]),
    urlType: z.enum(["exact", "subdomain"]),
    hasImpersonationGuard: z.boolean(),
    hasPasswordLeakageGuard: z.boolean(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateExtensionPolicyResponse = zExtensionPolicy;

export const zDeleteExtensionPolicyData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.number().int().gt(0),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteExtensionPolicyResponse = z.object({
  message: z.string(),
});

export const zGetExtensionPolicyData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.number().int().gt(0),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetExtensionPolicyResponse = zExtensionPolicy;

export const zUpdateExtensionPolicyData = z.object({
  body: z.object({
    url: z.string().min(1),
    type: z.enum(["allow", "block"]),
    urlType: z.enum(["exact", "subdomain"]),
    hasImpersonationGuard: z.boolean(),
    hasPasswordLeakageGuard: z.boolean(),
  }),
  path: z.object({
    id: z.number().int().gt(0),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateExtensionPolicyResponse = zExtensionPolicy;

export const zGetExtensionRulesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetExtensionRulesResponse = z.object({
  alerts: z.array(z.string()),
  infoBlocks: z.array(
    z.object({
      body: z.string(),
      id: z.number().int(),
      title: z.string(),
      url: z.string(),
      urlType: z.enum(["exact", "subdomain"]),
    }),
  ),
  policies: z.array(
    z.object({
      id: z.number().int(),
      created: z.string(),
      hasImpersonationGuard: z.boolean(),
      hasPasswordLeakageGuard: z.boolean(),
      type: z.enum(["allow", "block"]),
      url: z.string(),
      urlType: z.enum(["exact", "subdomain"]),
    }),
  ),
  detectionRules: z.array(
    z.object({
      id: z.number().int(),
      teamId: z.string(),
      name: z.string(),
      ruleType: z.string(),
      evaluationMode: z.enum(["url", "search_input"]),
      patterns: z.array(z.string()),
      keywords: z.array(z.string()),
      action: z.enum(["create_alert", "log_signal"]),
      severity: z.enum(["low", "medium", "high", "critical"]),
      enabled: z.boolean(),
      created: z.string().datetime(),
      updated: z.string().datetime(),
    }),
  ),
});

export const zCreateEntityData = z.object({
  body: zEntityUpsert.optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateEntityResponse = zEntity;

export const zDeleteEntityData = z.object({
  body: z.never().optional(),
  path: z.object({
    entityId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteEntityResponse = z.object({
  message: z.string(),
});

export const zGetEntityData = z.object({
  body: z.never().optional(),
  path: z.object({
    entityId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetEntityResponse = zEntity;

export const zUpdateEntityData = z.object({
  body: z
    .object({
      name: z.string().optional(),
      qualifiedName: z.string().optional(),
      icon: z.string().optional(),
      colorSchema: z
        .enum([
          "emerald",
          "yellow",
          "teal",
          "red",
          "blue",
          "neutral",
          "indigo",
          "sky",
          "orange",
          "purple",
          "violet",
          "green",
          "fuchsia",
          "rose",
          "cyan",
          "lime",
          "amber",
          "pink",
        ])
        .optional(),
      defaultValue: z.union([z.string(), z.null()]).optional(),
      description: z.union([z.string(), z.null()]).optional(),
      valueRegExpPattern: z.union([z.string(), z.null()]).optional(),
      entityClassId: z.string().optional(),
    })
    .optional(),
  path: z.object({
    entityId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateEntityResponse = zEntity;

export const zListTopEntitiesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      limit: z.number().int().gte(1).lte(100).optional().default(20),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListTopEntitiesResponse = z.array(zEntity);

export const zListEntitiesShortnamesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zListEntitiesShortnamesResponse = z.array(z.string());

export const zSearchEntitiesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    searchTerm: z.string().min(1),
  }),
});

/**
 * Default Response
 */
export const zSearchEntitiesResponse = z.array(zEntity);

export const zGetGraphDetailsData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z
    .object({
      workflowIds: z.union([z.string(), z.array(z.string())]).optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zGetGraphDetailsResponse = zGraphDetails;

export const zAddEdgesData = z.object({
  body: z.array(zGraphEdge).min(1).optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zAddEdgesResponse = z.array(zGraphEdge);

export const zUpdateEdgesData = z.object({
  body: z
    .array(
      z.object({
        id: z.string().min(1),
        value: z.string().min(1).optional(),
        sourceId: z.string().min(1).optional(),
        targetId: z.string().min(1).optional(),
        workflowIds: z.array(z.string()).optional(),
      }),
    )
    .min(1)
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateEdgesResponse = z.array(zGraphEdge);

export const zDeleteElementsData = z.object({
  body: z
    .array(
      z.object({
        id: z.string(),
        type: z.enum(["node", "edge"]),
      }),
    )
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteElementsResponse = z.object({
  deleted_nodes: z.number().optional(),
  deleted_edges: z.number().optional(),
});

export const zAddNodesData = z.object({
  body: z.array(zGraphNode).min(1).optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zAddNodesResponse = z.array(zGraphNode);

export const zUpdateNodesData = z.object({
  body: z
    .array(
      z.object({
        id: z.string().min(1),
        value: z.string().min(1).optional(),
        workflowIds: z.array(z.string()).optional(),
        position: z
          .object({
            x: z.number(),
            y: z.number(),
          })
          .optional(),
        flagColor: z.string().optional(),
        isFlagged: z.boolean().optional(),
        clusterId: z.string().optional(),
        icon: z.string().optional(),
        colorSchema: z
          .enum([
            "emerald",
            "yellow",
            "teal",
            "red",
            "blue",
            "neutral",
            "indigo",
            "sky",
            "orange",
            "purple",
            "violet",
            "green",
            "fuchsia",
            "rose",
            "cyan",
            "lime",
            "amber",
            "pink",
          ])
          .optional(),
        entityName: z.string().optional(),
        entityQualifiedName: z.string().optional(),
      }),
    )
    .min(1)
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateNodesResponse = z.array(zGraphNode);

export const zUpdateNodePositionsData = z.object({
  body: z.object({
    positions: z.array(
      z.object({
        id: z.string().min(1),
        position: z.object({
          x: z.number(),
          y: z.number(),
        }),
      }),
    ),
  }),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateNodePositionsResponse = z.array(zGraphNode);

export const zPostWorkspacesByIdUploadData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zPostWorkspacesByIdUploadResponse = z.object({
  jobId: z.string().min(1),
});

export const zListKnowledgeBasesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListKnowledgeBasesResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zKnowledgeBase),
  }),
);

export const zCreateKnowledgeBaseData = z.object({
  body: z.object({
    name: z.string().min(1),
    description: z.string().min(1),
    tags: z.array(z.string()).optional().default([]),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * KnowledgeBaseCreateResponse
 *
 * Default Response
 */
export const zCreateKnowledgeBaseResponse = zKnowledgeBase;

export const zDeleteKnowledgeBaseData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteKnowledgeBaseResponse = z.object({
  message: z.string(),
});

export const zGetKnowledgeBaseData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetKnowledgeBaseResponse = zKnowledgeBase;

export const zUpdateKnowledgeBaseData = z.object({
  body: z
    .object({
      name: z.string().min(1).optional(),
      description: z.string().min(1).optional(),
      tags: z.array(z.string()).optional().default([]),
    })
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * KnowledgeBaseUpdateResponse
 *
 * Default Response
 */
export const zUpdateKnowledgeBaseResponse = zKnowledgeBase;

export const zListKnowledgeBaseFilesData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * KnowledgeBaseFileListResponse
 *
 * Default Response
 */
export const zListKnowledgeBaseFilesResponse = z.array(
  z.object({
    id: z.string().uuid(),
    filename: z.string(),
    description: z.string(),
    tags: z.array(z.string()),
    mimeType: z.string(),
    sizeBytes: z.number(),
    uploadedAt: z.string().datetime(),
    workflowId: z.union([z.string().uuid(), z.null()]),
    processingStatus: zWorkflowStatus.optional(),
    downloadUrl: z.string().url(),
  }),
);

export const zPostKnowledgeBasesByIdFilesData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * KnowledgeBaseFileUploadResponse
 *
 * Default Response
 */
export const zPostKnowledgeBasesByIdFilesResponse = z.object({
  fileId: z.string().uuid(),
  workflowId: z.string().uuid(),
});

export const zDeleteKnowledgeBaseFileData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
    fileId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteKnowledgeBaseFileResponse = z.object({
  message: z.string(),
});

export const zListNotificationProvidersData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListNotificationProvidersResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zDestination),
  }),
);

export const zCreateNotificationProviderData = z.object({
  body: z
    .union([
      z.object({
        name: z.string().min(1),
        description: z.string().optional(),
        type: z.enum(["Slack"]),
        providerDetails: z.object({
          url: z.string().url(),
          channel: z.string().min(1),
          username: z.string().optional(),
        }),
      }),
      z.object({
        name: z.string().min(1),
        description: z.string().optional(),
        type: z.enum(["Email"]),
        providerDetails: z.object({
          email: z.string().email(),
          subject: z.string().min(1),
          text: z.string().min(1),
        }),
      }),
      z.object({
        name: z.string().min(1),
        description: z.string().optional(),
        type: z.enum(["Webhook"]),
        providerDetails: z.object({
          url: z.string().url(),
          method: z.enum(["GET", "POST", "PUT", "DELETE"]),
        }),
      }),
    ])
    .optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * NotificationProviderCreateResponse
 *
 * Default Response
 */
export const zCreateNotificationProviderResponse = zDestination;

export const zDeleteNotificationProviderData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteNotificationProviderResponse = z.object({
  message: z.string(),
});

export const zGetNotificationProviderData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetNotificationProviderResponse = zDestination;

export const zUpdateNotificationProviderData = z.object({
  body: z
    .union([
      z.object({
        name: z.string().min(1),
        description: z.string().optional(),
        type: z.enum(["Slack"]),
        providerDetails: z.object({
          url: z.string().url(),
          channel: z.string().min(1),
          username: z.string().optional(),
        }),
      }),
      z.object({
        name: z.string().min(1),
        description: z.string().optional(),
        type: z.enum(["Email"]),
        providerDetails: z.object({
          email: z.string().email(),
          subject: z.string().min(1),
          text: z.string().min(1),
        }),
      }),
      z.object({
        name: z.string().min(1),
        description: z.string().optional(),
        type: z.enum(["Webhook"]),
        providerDetails: z.object({
          url: z.string().url(),
          method: z.enum(["GET", "POST", "PUT", "DELETE"]),
        }),
      }),
    ])
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * UpdateNotificationProvidersResponse
 *
 * Default Response
 */
export const zUpdateNotificationProviderResponse = zDestination;

export const zSearchNotificationProvidersData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    searchTerm: z.string().min(1),
  }),
});

/**
 * ListNotificationProvidersResponse
 *
 * Default Response
 */
export const zSearchNotificationProvidersResponse = z.array(zDestination);

export const zListIntegrationsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListIntegrationsResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zIntegration),
  }),
);

export const zCreateIntegrationData = z.object({
  body: z
    .union([
      z.object({
        name: z.string(),
        type: z.enum(["Custom"]),
        iconUrl: z.union([z.string(), z.null()]).optional(),
        baseUrl: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        authenticationDetails: z.union([
          z.object({
            authenticationType: z.enum(["Basic"]),
            authenticationDetails: z.object({
              userName: z.string(),
              password: z.string(),
            }),
          }),
          z.object({
            authenticationType: z.enum(["APIKey"]),
            authenticationDetails: z.object({
              apiKey: z.string(),
              apiKeyName: z.string(),
              mappingType: z.enum(["Header", "QueryParameter"]),
            }),
          }),
          z.object({
            authenticationType: z.enum(["None"]),
          }),
        ]),
        apiParameters: z.array(zApiParameter).optional(),
        integrationDetails: z.object({
          connectionName: z.string(),
        }),
      }),
      z.object({
        name: z.string(),
        type: z.enum(["Google"]),
        iconUrl: z.union([z.string(), z.null()]).optional(),
        baseUrl: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        authenticationDetails: z.union([
          z.object({
            authenticationType: z.enum(["Basic"]),
            authenticationDetails: z.object({
              userName: z.string(),
              password: z.string(),
            }),
          }),
          z.object({
            authenticationType: z.enum(["APIKey"]),
            authenticationDetails: z.object({
              apiKey: z.string(),
              apiKeyName: z.string(),
              mappingType: z.enum(["Header", "QueryParameter"]),
            }),
          }),
          z.object({
            authenticationType: z.enum(["None"]),
          }),
        ]),
        apiParameters: z.array(zApiParameter).optional(),
        integrationDetails: z.object({
          clientEmail: z.string(),
          privateKey: z.string(),
          privateKeyId: z.string(),
          delegatedAdminEmail: z.string(),
        }),
      }),
      z.object({
        name: z.string(),
        type: z.enum(["LocalTransform"]),
        iconUrl: z.union([z.string(), z.null()]).optional(),
        baseUrl: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        authenticationDetails: z.union([
          z.object({
            authenticationType: z.enum(["Basic"]),
            authenticationDetails: z.object({
              userName: z.string(),
              password: z.string(),
            }),
          }),
          z.object({
            authenticationType: z.enum(["APIKey"]),
            authenticationDetails: z.object({
              apiKey: z.string(),
              apiKeyName: z.string(),
              mappingType: z.enum(["Header", "QueryParameter"]),
            }),
          }),
          z.object({
            authenticationType: z.enum(["None"]),
          }),
        ]),
        apiParameters: z.array(zApiParameter).optional(),
      }),
    ])
    .optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * IntegrationCreateResponse
 *
 * Default Response
 */
export const zCreateIntegrationResponse = zIntegration;

export const zDeleteIntegrationData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteIntegrationResponse = z.object({
  message: z.string(),
});

export const zGetIntegrationData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetIntegrationResponse = zIntegration;

export const zUpdateIntegrationData = z.object({
  body: z
    .union([
      z.object({
        name: z.string(),
        type: z.enum(["Custom"]),
        iconUrl: z.union([z.string(), z.null()]).optional(),
        baseUrl: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        authenticationDetails: z.union([
          z.object({
            authenticationType: z.enum(["Basic"]),
            authenticationDetails: z.object({
              userName: z.string(),
              password: z.string(),
            }),
          }),
          z.object({
            authenticationType: z.enum(["APIKey"]),
            authenticationDetails: z.object({
              apiKey: z.string(),
              apiKeyName: z.string(),
              mappingType: z.enum(["Header", "QueryParameter"]),
            }),
          }),
          z.object({
            authenticationType: z.enum(["None"]),
          }),
        ]),
        apiParameters: z.array(zApiParameter).optional(),
        integrationDetails: z.object({
          connectionName: z.string(),
        }),
      }),
      z.object({
        name: z.string(),
        type: z.enum(["Google"]),
        iconUrl: z.union([z.string(), z.null()]).optional(),
        baseUrl: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        authenticationDetails: z.union([
          z.object({
            authenticationType: z.enum(["Basic"]),
            authenticationDetails: z.object({
              userName: z.string(),
              password: z.string(),
            }),
          }),
          z.object({
            authenticationType: z.enum(["APIKey"]),
            authenticationDetails: z.object({
              apiKey: z.string(),
              apiKeyName: z.string(),
              mappingType: z.enum(["Header", "QueryParameter"]),
            }),
          }),
          z.object({
            authenticationType: z.enum(["None"]),
          }),
        ]),
        apiParameters: z.array(zApiParameter).optional(),
        integrationDetails: z.object({
          clientEmail: z.string(),
          privateKey: z.string(),
          privateKeyId: z.string(),
          delegatedAdminEmail: z.string(),
        }),
      }),
      z.object({
        name: z.string(),
        type: z.enum(["LocalTransform"]),
        iconUrl: z.union([z.string(), z.null()]).optional(),
        baseUrl: z.string(),
        description: z.union([z.string(), z.null()]).optional(),
        authenticationDetails: z.union([
          z.object({
            authenticationType: z.enum(["Basic"]),
            authenticationDetails: z.object({
              userName: z.string(),
              password: z.string(),
            }),
          }),
          z.object({
            authenticationType: z.enum(["APIKey"]),
            authenticationDetails: z.object({
              apiKey: z.string(),
              apiKeyName: z.string(),
              mappingType: z.enum(["Header", "QueryParameter"]),
            }),
          }),
          z.object({
            authenticationType: z.enum(["None"]),
          }),
        ]),
        apiParameters: z.array(zApiParameter).optional(),
      }),
    ])
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * UpdateIntegrationsResponse
 *
 * Default Response
 */
export const zUpdateIntegrationResponse = zIntegration;

export const zListGraphsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListGraphsResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zGraphSummary),
  }),
);

export const zCreateGraphData = z.object({
  body: z.object({
    name: z.string().min(1),
    format: zGraphLayout.optional(),
    clustersEnabled: z.boolean().optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateGraphResponse = zGraphSummary;

export const zDeleteGraphData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteGraphResponse = z.object({
  message: z.string(),
});

export const zCopyGraphData = z.object({
  body: z.object({
    name: z.string().min(1),
    format: zGraphLayout.optional(),
    clustersEnabled: z.boolean().optional(),
    nodeIds: z.array(z.string()).min(1).optional(),
    edgeIds: z.array(z.string()).min(1).optional(),
  }),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCopyGraphResponse = zGraphSummary;

export const zGetGraphData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetGraphResponse = zGraphSummary;

export const zUpdateGraphData = z.object({
  body: z
    .object({
      name: z.string().min(1).optional(),
      format: zGraphLayout.optional(),
      clustersEnabled: z.boolean().optional(),
    })
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateGraphResponse = zGraphSummary;

export const zSearchGraphsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    searchTerm: z.string().min(1),
  }),
});

/**
 * Default Response
 */
export const zSearchGraphsResponse = z.array(zGraphSummary);

export const zListPollersData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      cursor: z.string().optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListPollersResponse = z.object({
  nextCursor: z.union([z.string(), z.null()]),
  hasMore: z.boolean(),
  items: z.array(zPoller),
});

export const zCreatePollerData = z.object({
  body: z.object({
    name: z.string(),
    queryActionId: z.string(),
    alertSourceId: z.string(),
    inputMappings: z.array(zInputParameter).optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreatePollerResponse = zPoller;

export const zDeletePollerData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeletePollerResponse = z.object({
  message: z.string(),
});

export const zGetPollerData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetPollerResponse = zPoller;

export const zUpdatePollerData = z.object({
  body: z
    .object({
      name: z.string().optional(),
      queryActionId: z.string().optional(),
      alertSourceId: z.string().optional(),
      inputMappings: z.array(zInputParameter).optional(),
    })
    .optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdatePollerResponse = zPoller;

export const zSearchPollersData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    searchTerm: z.string().min(1),
  }),
});

/**
 * Default Response
 */
export const zSearchPollersResponse = z.array(zPoller);

export const zExecuteSavedQueryActionData = z.object({
  body: z.object({
    inputMappings: z.array(zInputParameter),
  }),
  path: z.object({
    queryActionId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zExecuteSavedQueryActionResponse = z.object({
  statusCode: z.number(),
  rawResponse: z.string(),
  isError: z.boolean(),
  message: z.string(),
  outputEntities: z
    .array(
      z.object({
        id: z.string(),
        relationship: z.string(),
        value: z.string(),
        qualifiedName: z.string(),
        parentId: z.union([z.string(), z.null()]).optional(),
      }),
    )
    .optional(),
});

export const zTestQueryActionData = z.object({
  body: z.object({
    name: z.string(),
    method: z.enum(["GET", "POST", "PUT", "DELETE"]),
    url: z.string(),
    description: z.union([z.string(), z.null()]).optional(),
    integrationId: z.string(),
    requestPayload: z.union([z.string(), z.null()]).optional(),
    agenticSettingsId: z.union([z.string(), z.null()]).optional(),
    type: z.enum(["poller", "enrichment"]),
    apiParameters: z.array(zApiParameter).optional(),
    outputMappings: z.array(
      z.object({
        qualifiedName: z.string(),
        relationship: z.string(),
        liquidTemplate: z.string(),
        outputType: z.enum(["STRING", "LIST"]),
        isRoot: z.union([z.boolean(), z.null()]).optional(),
      }),
    ),
    inputEntities: z
      .array(
        z.object({
          qualifiedName: z.string(),
        }),
      )
      .optional(),
    inputMappings: z.array(zInputParameter),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zTestQueryActionResponse = z.object({
  statusCode: z.number(),
  rawResponse: z.string(),
  isError: z.boolean(),
  message: z.string(),
  outputEntities: z
    .array(
      z.object({
        id: z.string(),
        relationship: z.string(),
        value: z.string(),
        qualifiedName: z.string(),
        parentId: z.union([z.string(), z.null()]).optional(),
      }),
    )
    .optional(),
});

export const zListQueryActionData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
      integrationId: z.string().optional(),
      type: z.enum(["poller", "enrichment"]).optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListQueryActionResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zQueryAction),
  }),
);

export const zCreateQueryActionData = z.object({
  body: z.object({
    name: z.string(),
    method: z.enum(["GET", "POST", "PUT", "DELETE"]),
    url: z.string(),
    description: z.union([z.string(), z.null()]).optional(),
    integrationId: z.string(),
    requestPayload: z.union([z.string(), z.null()]).optional(),
    agenticSettingsId: z.union([z.string(), z.null()]).optional(),
    type: z.enum(["poller", "enrichment"]),
    apiParameters: z.array(zApiParameter).optional(),
    outputMappings: z.array(
      z.object({
        qualifiedName: z.string(),
        relationship: z.string(),
        liquidTemplate: z.string(),
        outputType: z.enum(["STRING", "LIST"]),
        isRoot: z.union([z.boolean(), z.null()]).optional(),
      }),
    ),
    inputEntities: z
      .array(
        z.object({
          qualifiedName: z.string(),
        }),
      )
      .optional(),
    defaultAgenticSettings: z
      .object({
        confidenceLevel: z.enum(["low", "medium", "high"]),
        costWeight: z.number().int(),
        maxRetries: z.number().int(),
        preconditions: z.string(),
        timeoutSeconds: z.number().int(),
      })
      .optional(),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * CreateQueryActionResponse
 *
 * Default Response
 */
export const zCreateQueryActionResponse = zQueryAction;

export const zDeleteQueryActionData = z.object({
  body: z.never().optional(),
  path: z.object({
    queryActionId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteQueryActionResponse = z.object({
  message: z.string(),
});

export const zGetQueryActionData = z.object({
  body: z.never().optional(),
  path: z.object({
    queryActionId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetQueryActionResponse = zQueryAction;

export const zUpdateQueryActionData = z.object({
  body: z.object({
    name: z.string(),
    method: z.enum(["GET", "POST", "PUT", "DELETE"]),
    url: z.string(),
    description: z.union([z.string(), z.null()]).optional(),
    integrationId: z.string(),
    requestPayload: z.union([z.string(), z.null()]).optional(),
    agenticSettingsId: z.union([z.string(), z.null()]).optional(),
    type: z.enum(["poller", "enrichment"]),
    apiParameters: z.array(zApiParameter).optional(),
    outputMappings: z.array(
      z.object({
        qualifiedName: z.string(),
        relationship: z.string(),
        liquidTemplate: z.string(),
        outputType: z.enum(["STRING", "LIST"]),
        isRoot: z.union([z.boolean(), z.null()]).optional(),
      }),
    ),
    inputEntities: z
      .array(
        z.object({
          qualifiedName: z.string(),
        }),
      )
      .optional(),
    defaultAgenticSettings: z
      .object({
        confidenceLevel: z.enum(["low", "medium", "high"]),
        costWeight: z.number().int(),
        maxRetries: z.number().int(),
        preconditions: z.string(),
        timeoutSeconds: z.number().int(),
      })
      .optional(),
  }),
  path: z.object({
    queryActionId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * UpdateQueryActionResponse
 *
 * Default Response
 */
export const zUpdateQueryActionResponse = zQueryAction;

export const zSearchQueryActionsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    type: z.enum(["poller", "enrichment"]).optional(),
    searchTerm: z.string().min(1),
  }),
});

/**
 * Default Response
 */
export const zSearchQueryActionsResponse = z.array(zQueryAction);

export const zQueryActionsForNodeData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zQueryActionsForNodeResponse = z.array(zQueryActionForNode);

export const zListUsersData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      currentPage: zPageParam.optional(),
      pageSize: zPageSizeParam.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zListUsersResponse = zPaginatedResponse.and(
  z.object({
    items: z.array(zUser),
  }),
);

export const zCreateUserData = z.object({
  body: z.object({
    fullName: z.string(),
    email: z.string(),
    status: z.enum(["Active", "Pending", "Disabled"]),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zCreateUserResponse = zUser;

export const zDeleteUserData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zDeleteUserResponse = z.object({
  message: z.string(),
});

export const zUpdateUserData = z.object({
  body: z.object({
    fullName: z.string(),
    email: z.string(),
    status: z.enum(["Active", "Pending", "Disabled"]),
  }),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zUpdateUserResponse = zUser;

export const zGetWorkflowsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      graphId: z.string().optional(),
      workflowIds: z.string().optional(),
      sortDirection: zSortDirection.optional(),
    })
    .optional(),
});

/**
 * Default Response
 */
export const zGetWorkflowsResponse = z.array(zWorkflow);

export const zCreateWorkflowOrLocalActionData = z.object({
  body: z.object({
    graphId: z.string(),
    nodeId: z.string(),
    queryAction: z.object({
      id: z.string(),
      inputParameters: z.array(zInputParameter),
      selectedOutputMappingIds: z.array(z.string()).min(1),
    }),
  }),
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zCreateWorkflowOrLocalActionResponse = z.union([
  zGraphDetails,
  z.object({
    id: z.string(),
  }),
]);

export const zGetWorkflowData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetWorkflowResponse = zWorkflow;

export const zGetWorkflowsStreamData = z.object({
  body: z.never().optional(),
  path: z.object({
    graphId: z.string().uuid(),
  }),
  query: z.never().optional(),
});

/**
 * Server-Sent Events stream
 */
export const zGetWorkflowsStreamResponse = zSseEvent;

export const zGetWorkflowRawDataData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zGetWorkflowRawDataResponse = z.record(z.unknown());

export const zReceiveWebhookData = z.object({
  body: z.record(z.unknown()).optional(),
  path: z.object({
    webhookId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zReceiveWebhookResponse = z.object({
  workflowId: z.string(),
  graphId: z.string(),
});

export const zTriggerAgentData = z.object({
  body: z.object({
    prompt: z.string(),
    data: z.record(z.unknown()).optional(),
  }),
  path: z.object({
    webhookId: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * Default Response
 */
export const zTriggerAgentResponse = z.object({
  workflowId: z.string(),
  graphId: z.string(),
});
